import { FunctionComponent } from 'react';

import Icon from '../Icon';
import { IconPropsInterface } from '../Icon.types';

const ChevronFirstIcon: FunctionComponent<IconPropsInterface> = ({
  color = 'black',
  size = '24px',
  ...rest
}) => (
  <Icon color={color} size={size} {...rest}>
    <path
      d="M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
      fill="currentColor"
    />
    <path d="M24 24H0V0h24v24z" fill="none" />
  </Icon>
);

ChevronFirstIcon.displayName = 'ChevronFirstIcon';

export default ChevronFirstIcon;
